const API_BASE = process.env.REACT_APP_BASE_URL || "http://localhost:5000";

type AuthFetchOptions = RequestInit & {
  token?: string | null;
  json?: boolean;
};

const AUTH_TOKEN_KEY = "auth_token";
const AUTH_USER_KEY = "auth_user";
const LEGACY_KEYS = ["user", "username", "rol"];

export function api(path: string) {
  return `${API_BASE}${path}`;
}

function clearAuthStorage() {
  try {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    localStorage.removeItem(AUTH_USER_KEY);

    for (const key of LEGACY_KEYS) {
      localStorage.removeItem(key);
    }
  } catch (error) {
    console.error("No se pudo limpiar auth en localStorage", error);
  }
}

function redirectToLogin() {
  if (window.location.pathname !== "/") {
    window.location.replace("/");
  }
}

export async function authFetch(path: string, options: AuthFetchOptions = {}) {
  const { token, json = false, headers, ...rest } = options;

  const normalizedHeaders = new Headers(headers || {});

  if (json && !normalizedHeaders.has("Content-Type")) {
    normalizedHeaders.set("Content-Type", "application/json");
  }

  if (token) {
    normalizedHeaders.set("Authorization", `Bearer ${token}`);
  }

  const response = await fetch(api(path), {
    ...rest,
    headers: normalizedHeaders,
  });

  if (response.status === 401 || response.status === 403) {
    clearAuthStorage();
    redirectToLogin();
  }

  return response;
}